/* ============================================================
   AGILITE QR SIGN-UP  — landing-page logic (ISOLATED asset)
   ------------------------------------------------------------
   Isolation principle: this is a self-contained asset. It reads
   window globals (__AGB_REGION, existing visitorID) and never
   edits the Scarcity Engine, theme core, or cae-client.

   What it does (Step 1 — the "certain fact"):
     - decode the scanned token -> resolve product (stub for now)
     - capture EMAIL + consent + scanned SKU + session/visitor
     - POST that capture to the endpoint (stub logs it for now)
   No OCR, no fuzzy matching, no receipt — those are later steps.
   ============================================================ */
(function () {
  'use strict';

  var REGION   = window.__AGB_REGION || 'ROW';           // store/config region (from Liquid). NOT the consent authority.
  var ENDPOINT = window.__AGB_QR_ENDPOINT || null;       // null in prototype => log instead of POST

  // ---- identity: reuse existing storefront id, else disposable -----
  // A phone QR scan usually has NO prior visitorID; that's fine —
  // EMAIL is the durable anchor, the vid is only a bonus link.
  function getVisitor() {
    try {
      var existing = localStorage.getItem('visitorID') || localStorage.getItem('viewerId');
      if (existing) return { id: existing, minted: false };
    } catch (e) {}
    return { id: 'qr-' + rand(), minted: true };
  }
  function getSessionId() { return 'sess-' + rand(); }     // mirrors storefront SE_SessionId
  function rand() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }

  // ---- resolve the scanned product from the URL ----
  // REAL production cards use:  /pages/free-patch-offer?sku=<CANONICAL SKU>  (plaintext, per-SKU).
  // Also supported: ?t=<signed token> (serialized/per-unit future) and bare ?<legacy brief form>.
  function resolveScan() {
    var params = new URLSearchParams(window.location.search);
    var skuParam = params.get('sku');
    if (skuParam) {
      return { sku: skuParam.trim().toUpperCase(), serial: null, region: null,
               channel: null, batch: null, _legacy: false, _source: 'sku-param' };
    }
    var t = params.get('t');
    if (t) { var d = window.AGBQRToken.decode(t); d._source = 'signed-token'; return d; }
    var qs = window.location.search.replace(/^\?/, '');
    var first = qs ? qs.split('&')[0] : '';
    if (first && first.indexOf('=') === -1) {
      var dl = window.AGBQRToken.decode(decodeURIComponent(first)); dl._source = 'legacy'; return dl;
    }
    return null;
  }

  function resolveProduct(sku) {
    if (!sku) return null;
    return (window.AGB_SAMPLE_CATALOG || {})[sku] || null;
  }

  // ---- state ----
  var decoded = resolveScan();
  var scanUrl = window.location.pathname + window.location.search;
  var visitor = getVisitor();
  var session = getSessionId();
  var product = decoded ? resolveProduct(decoded.sku) : null;

  // The capture payload — the exact "certain fact" we bank at Step 1.
  function buildPayload(email, consent) {
    return {
      source:        decoded && decoded._legacy ? 'qr-legacy' : 'qr_offline',
      email:         email || null,
      consent:       !!consent,
      sku:           decoded ? decoded.sku : null,
      serial:        decoded ? decoded.serial : null,
      region:        (decoded && decoded.region) || REGION,   // consent authority = server geo-IP, not this
      channel:       (decoded && decoded.channel) || null,
      batch:         (decoded && decoded.batch) || null,
      sessionId:     session,
      visitorId:     visitor.id,
      visitorMinted: visitor.minted,
      scanSource:    decoded ? decoded._source : null,
      scannedUrl:    scanUrl,
      scannedAt:     new Date().toISOString()
    };
  }

  // ---- render: scanned product summary (with real image when resolvable) ----
  function renderProduct() {
    var el = document.getElementById('product');
    if (!decoded) {
      // No scan context at all (typed/shared URL). The offer is tied to a
      // physical product tag — per the brief there is no tag-less signup, so
      // the form never shows. Legacy bare tokens are NOT this case: those
      // decode (with _legacy) and still register.
      // Wording: people land here from the WRONG QR code (packaging, a flyer,
      // a shared link), so say so plainly.
      el.innerHTML = '<div class="prod-note">This page isn&rsquo;t meant to be opened on its own. ' +
        'If a QR code brought you here, it was the wrong one.</div>';
      ['signup-form', 'headline', 'sub'].forEach(function (id) {
        var n = document.getElementById(id); if (n) n.hidden = true;
      });
      return;
    }
    if (decoded._legacy) {
      el.innerHTML = '<div class="prod-note">Legacy code <code>' + esc(decoded._raw) +
        '</code> — product not resolved. You can still register.</div>';
      return;
    }
    paintProduct(product);           // paint what we know up front (catalog, or a placeholder)
    enrichFromShopify(decoded.sku);  // async: upgrade to the REAL image + name + PDP link
  }

  function paintProduct(p) {
    var el = document.getElementById('product');
    if (!el || !decoded) return;
    var name  = (p && p.name)  || 'Your Agilite item';
    var color = (p && p.color) || '';
    var size  = (p && p.size)  || '';
    var media = (p && p.image)
      ? '<img class="prod-img" src="' + esc(p.image) + '" alt="' + esc(name) + '" loading="lazy">'
      : '<span class="prod-swatch" style="background:' + esc((p && p.swatch) || '#747959') + '"></span>';
    var nameHtml = (p && p.url)
      ? '<a class="prod-name" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(name) + '</a>'
      : '<div class="prod-name">' + esc(name) + '</div>';
    el.innerHTML =
      '<div class="prod">' + media +
        '<div class="prod-meta">' + nameHtml +
          '<div class="prod-attrs">' + esc(color) + (size ? ' &middot; ' + esc(size) : '') + '</div>' +
          '<div class="prod-sku">SKU ' + esc(decoded.sku) +
            (decoded.serial ? ' &middot; unit #' + esc(decoded.serial) : '') + '</div>' +
        '</div>' +
      '</div>';
  }

  // Keyless product lookup via Shopify predictive search — matches the variant SKU and returns
  // the product image/title/URL. Works on the live storefront (same-origin); on the local
  // prototype the endpoint 404s and we silently keep the catalog fallback.
  function enrichFromShopify(sku) {
    if (!sku || typeof fetch !== 'function') return;
    var url = '/search/suggest.json?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[options][limit]=5' +
      '&resources[options][fields]=title,variants.sku';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (data) {
        var list = data && data.resources && data.resources.results && data.resources.results.products;
        if (!list || !list.length) { enrichUnlisted(sku); return; }
        var match = pickBySku(list, sku);
        var img = match.image || (match.featured_image && (match.featured_image.url || match.featured_image));
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        paintProduct({
          name:  match.title || 'Your Agilite item',
          color: (product && product.color) || '',
          size:  (product && product.size) || '',
          image: img || null,
          url:   match.url || null,
          swatch: (product && product.swatch) || '#747959'
        });
      })
      .catch(function () { /* keep catalog/placeholder */ });
  }

  // Storefront search can't see LIVE-BUT-UNLISTED products (hidden from
  // search/sitemap on purpose) — but scanned tags reference them all the
  // same. Fall back to the estate's own SKU lookup (vid-email-resolve
  // /sku-product: catalog mirror + Storefront-by-GID), which resolves them.
  function enrichUnlisted(sku) {
    var base = window.AGB_VID_EMAIL_URL || null;
    if (!base || typeof fetch !== 'function') return;
    fetch(String(base).replace(/\/+$/, '') + '/sku-product', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sku: sku })
    }).then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.found || !d.title) return;   // keep the placeholder
        paintProduct({
          name: d.title,
          color: d.color || '',
          size: d.size || '',
          image: d.image || null,
          url: d.url || null,
          swatch: '#747959'
        });
      })
      .catch(function () { /* keep placeholder */ });
  }

  function pickBySku(list, sku) {
    for (var i = 0; i < list.length; i++) {
      var vs = list[i].variants || [];
      for (var j = 0; j < vs.length; j++) {
        if (vs[j].sku && String(vs[j].sku).toUpperCase() === sku) return list[i];
      }
    }
    return list[0];
  }

  function renderDebug(payload) {
    var el = document.getElementById('debug-pre');
    if (!el) return; // the live theme page omits the dev debug panel
    el.textContent = JSON.stringify(payload || buildPayload('(pending)', false), null, 2);
  }

  // ---- existing-customer skip (2026-08-17) -----------------------------
  // A shopper who already bought on the website needs NO receipt — their
  // order history is stronger proof than any photo. In parallel with the
  // signup write, ask vid-email-resolve /customer-check {email, vid};
  // a match routes the success screen straight to "patch unlocked".
  // Best-effort: any failure/timeout (3.5s) => null => normal receipt flow.
  function customerCheck(payload) {
    if (window.__AGB_CUSTOMER_CHECK_STUB !== undefined && window.__AGB_CUSTOMER_CHECK_STUB !== null) {
      var stub = window.__AGB_CUSTOMER_CHECK_STUB;
      return new Promise(function (res) {
        window.setTimeout(function () {
          res(stub === true ? { existing_customer: true, matched_by: 'email' } : stub);
        }, 600);
      });
    }
    var base = window.AGB_VID_EMAIL_URL || null;
    if (!base || typeof fetch !== 'function') return Promise.resolve(null);
    var guard = new Promise(function (res) { window.setTimeout(function () { res(null); }, 3500); });
    var call = fetch(String(base).replace(/\/+$/, '') + '/customer-check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: payload.email, vid: payload.visitorId, sku: payload.sku })
    }).then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return Promise.race([call, guard]);
  }

  // ---- submit ----
  document.getElementById('signup-form').addEventListener('submit', function (e) {
    e.preventDefault();
    if (!decoded) return;   // no scanned tag = no signup (form is hidden; belt and braces)
    var email   = document.getElementById('email').value.trim();
    var consent = document.getElementById('consent').checked;

    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    toggle('email-err', !emailOk);
    toggle('consent-err', !consent);
    if (!emailOk || !consent) return;

    var payload = buildPayload(email, consent);
    renderDebug(payload);
    submitCapture(payload, customerCheck(payload));
  });

  function submitCapture(payload, checkPromise) {
    var btn = document.getElementById('submit');
    btn.disabled = true; btn.textContent = 'Unlocking…';
    var done = function () {
      (checkPromise || Promise.resolve(null)).then(function (check) {
        showSuccess(payload, check);
      });
    };
    if (ENDPOINT) {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Store-Region': payload.region },
        body: JSON.stringify(payload)
      }).then(done).catch(done);
    } else {
      // Prototype — no backend yet. Log the capture that WOULD be sent to /qr/register.
      console.log('[AGB QR] capture (stub, no endpoint):', payload);
      window.setTimeout(done, 350);
    }
  }

  function showSuccess(payload, check) {
    ['product', 'signup-form', 'headline', 'sub'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.hidden = true;
    });
    var s = document.getElementById('success');
    // ALREADY GRANTED (2026-09-14): they hold an active patch from an earlier
    // visit — commonly a receipt that was rejected and then approved by hand
    // after they left. They must NOT be asked for another receipt: re-uploading
    // the same photo dedups to the same receipt and the same verdict.
    if (check && check.already_granted && check.claim_url) {
      s.hidden = false;
      s.innerHTML =
        '<div class="ok-badge">&#10003; Patch approved</div>' +
        '<h2 class="ag-heading">Your Patch Is Ready</h2>' +
        '<p class="sub">Your receipt was approved, so there&rsquo;s nothing more to send. ' +
        'Claim <strong>' + esc(check.patch_title || 'your free patch') + '</strong> below — ' +
        'it ships free with your next order.</p>' +
        '<a class="ag-btn block" id="claim-link" href="' + esc(check.claim_url) + '">' +
        'Claim your free patch &rarr;</a>';
      return;
    }
    // EXISTING WEB CUSTOMER: order history verified server-side — the patch
    // unlocks instantly, the receipt step is never offered. When the server
    // minted (or re-found) a claim link, take them straight to the free item
    // page per the brief ("immediately redirected"), with a button fallback.
    if (check && check.existing_customer) {
      s.hidden = false;
      var url = check.claim_url || null;
      var patch = check.patch_title || 'your free patch';
      var claimBlock = url
        ? '<a class="ag-btn block" id="claim-link" href="' + esc(url) + '">Claim your free patch &rarr;</a>'
        : '';
      if (check.claim === 'already') {
        s.innerHTML =
          '<div class="ok-badge">✓ Purchase verified</div>' +
          '<h2 class="ag-heading">Already Registered</h2>' +
          '<p class="sub">It looks like you&rsquo;ve already registered this product. ' +
          (url ? 'Your patch is still waiting — claim <strong>' + esc(patch) + '</strong> below.'
               : '<strong>' + esc(payload.email) + '</strong> has already received its free patch.') +
          '</p>' + claimBlock;
        return;
      }
      s.innerHTML =
        '<div class="ok-badge">✓ Patch unlocked</div>' +
        '<h2 class="ag-heading">Purchase Verified</h2>' +
        '<p class="sub">We found the Agilite order history for <strong>' + esc(payload.email) +
        '</strong> — no receipt needed.' +
        (url ? ' Taking you to claim <strong>' + esc(patch) + '</strong>&hellip;'
             : ' Watch your inbox for your free patch.') + '</p>' + claimBlock;
      if (url) {
        // No interstitial delay — go straight to the free-item page.
        try { window.top.location.href = url; }
        catch (e) { window.location.href = url; }
      }
      return;
    }
    // Receipt step (qr-receipt.js) only offered when its endpoint is configured —
    // the live page must never promise an unbuilt step.
    var receiptOn = !!(window.AGBQrReceipt && window.AGBQrReceipt.enabled());
    if (receiptOn) {
      // No interstitial (Dorian 2026-08-18: the "One More Step" click was a
      // useless stop) — signup lands DIRECTLY on the receipt step.
      s.hidden = true;
      window.AGBQrReceipt.show(payload);
      return;
    }
    s.hidden = false;
    s.innerHTML =
      '<div class="ok-badge">✓ You’re in</div>' +
      '<h2 class="ag-heading">Your Exclusive Patch Is Reserved</h2>' +
      '<p class="sub">We’ve linked <strong>' + esc(payload.email) + '</strong> to ' +
        (payload.sku ? 'your scanned item (<strong>' + esc(payload.sku) + '</strong>).'
                     : 'your registration.') + '</p>' +
      '<p class="fine">Keep an eye on your inbox for your reward.</p>';
  }

  // ---- helpers ----
  function toggle(id, show) { var el = document.getElementById(id); if (el) el.hidden = !show; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---- boot ----
  renderProduct();
  renderDebug(null);
  // Stamp the scanned SKU onto the form so signup-vid-link.js sends it and
  // users_drip records WHICH product tag drove this signup.
  if (decoded && decoded.sku && !decoded._legacy) {
    var _f = document.getElementById('signup-form');
    if (_f) _f.setAttribute('data-vid-sku', decoded.sku);
  }
})();
